import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrebuildCircuitComponent } from './prebuild-circuit.component';
import { SharedModule } from '../../shared.module';
import { SafePipesModule } from '../../pipes/safe-pipe.module';



@NgModule({
  declarations: [
    PrebuildCircuitComponent,
    ],
  imports: [
    CommonModule,
    SafePipesModule
  ],
  exports: [
    PrebuildCircuitComponent,
  ]
})
export class PrebuildCircuitModule { }
